import { defer } from "@runtime/utils";

export function equalArray(a: any, b: any) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

export function onceAtATime(label: string) {
    let ready = Promise.resolve();
    return async function <ReturnType>(f: () => Promise<ReturnType>) {
        await ready;
        const deferred = defer();
        ready = deferred.promise;
        try {
            return await f();
        } finally {
            deferred.resolve(undefined);
        }
    };
}
